<template>
  <DxTabPanel>
    <DxItem
      title="Bitacora de Sesiones BI"
      template="dashboar-bitacora-sessions-tab"
    />
    <template #dashboar-bitacora-sessions-tab>
      <b-card :class="[dark ? 'dark-mode-page' : '']" >
        <b-row>
          <b-col class="form-group col-6">
            <label :class="[dark ? 'text-white': '']"  >Fecha inicio:</label>
            <!-- :min="beforeMonth" -->
            <!-- :max="form.date_end" -->
            <input
              v-model="form.date_init"
              :disabled="isLoading"
              type="datetime-local"
              class="form-control form-control-sm"
            />
          </b-col>
          <b-col class="form-group col-6">
            <label :class="[dark ? 'text-white': '']"  >Fecha fin:</label>
            <input
              v-model="form.date_end"
              :disabled="isLoading"
              :min="form.date_init"
              type="datetime-local"
              class="form-control form-control-sm"
            />
          </b-col>
          <b-col>
            <button
              class="btn btn-sm btn-primary btn-circle"
              @click="onGenerateBitacoraSessions()"
              :disabled="isLoading"
            >
              <span v-if="!isLoading">
                <i class="fa fa-regular fa-file-excel"></i>
                Generar Reporte
              </span>
              <span v-else>Cargando...</span>
            </button>
            <!-- <button
              class="btn btn-sm btn-secondary btn-circle mx-5"
              :disabled="isLoading"
              @click="onReportBI()"
              >
              <span>
                <i class="fa fa-address-card text-success"></i>
                Navegar a Reporte BI
              </span>
            </button> -->
          </b-col>
        </b-row>
      </b-card>
    </template>
  </DxTabPanel>
</template>

<script>
import moment from "moment";
import axios from "axios";
import { saveAs } from "file-saver-es";
import { Workbook } from "exceljs";
import { DxTabPanel, DxItem } from "devextreme-vue/tab-panel";
import { mapGetters } from "vuex";

export default {
  components: {
    DxTabPanel,
    DxItem,
  },
  computed: {
    ...mapGetters({
      dark: "mode/getTheme",
    }),
  },
  data() {
    return {
      isLoading: false,
      form: {
        date_init: moment().format("YYYY-MM-DDT06:00:00"),
        date_end: moment().format("YYYY-MM-DDT18:00:00"),
      },
    };
  },
  methods: {
    async onGenerateBitacoraSessions() {
      this.isLoading = true;
      try {
        const { status, data } = await axios.post(
          "/bitacoraReportDashboard",
          this.form
          //   { responseType: "arraybuffer" }
        );
        if (status === 200 && data.message === "success") {
          this.$swal.fire("Información!", data.information, "success");
          const {
            data: { items },
          } = data;
          console.log({ items });
          await this.onGenerateReport(items);
          this.isLoading = false;
        } else {
          console.log({ data, status });
          this.$swal.fire(
            "Información!",
            "No se ha encontrado informacion en ese rango de fechas!",
            "info"
          );
          this.isLoading = false;
          return;
        }
      } catch (error) {
        console.log({ error });
        this.$swal.fire(
          "Error!",
          "Ocurrió un error al generar el reporte. Inténtelo nuevamente.",
          "error"
        );
        this.isLoading = false;
      }
    },
    async onGenerateReport(items = []) {
      const workbook = new Workbook();

      // Configurar metadatos del libro
      workbook.creator = "Sistema de Reportes - SIPREM";
      workbook.lastModifiedBy = "Sistema de Reportes - SIPREM";
      workbook.created = new Date();
      workbook.modified = new Date();

      // Crear una hoja de trabajo
      const worksheet = workbook.addWorksheet("Reporte Bitacora de Usuarios", {
        pageSetup: {
          paperSize: 9, // A4
          orientation: "landscape",
        },
      });

      // columnas
      worksheet.columns = [
        { header: "Nombre", key: "nombre", width: 20 },
        { header: "Usuario", key: "usuario", width: 20 },
        { header: "Fecha", key: "date", width: 25 },
      ];

      // Estilizar la fila de encabezados
      const headerRow = worksheet.getRow(1);
      headerRow.font = { bold: true, color: { argb: "FFFFFF" } };
      headerRow.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "366092" },
      };
      headerRow.alignment = { horizontal: "center", vertical: "middle" };
      headerRow.height = 25;

      // Agregar los datos
      items.forEach((item, index) => {
        const row = worksheet.addRow({
          nombre: item.nombre,
          usuario: item.usuario,
          date: item.date,
        });

        // Alternar colores de filas para mejor legibilidad
        if (index % 2 === 0) {
          row.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "F2F2F2" },
          };
        }

        // Centrar el contenido
        row.alignment = { horizontal: "center", vertical: "middle" };
        row.height = 20;
      });

      // Agregar bordes a todas las celdas con datos
      const totalRows = items.length + 1; // +1 por el header
      for (let i = 1; i <= totalRows; i++) {
        for (let j = 1; j <= 3; j++) {
          // 3 columnas
          const cell = worksheet.getCell(i, j);
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        }
      }

      // Agregar información adicional
      const summaryRow = worksheet.addRow([]);
      summaryRow.height = 10;

      const infoRow = worksheet.addRow([
        "Total de registros:",
        items.length,
        "",
      ]);
      infoRow.font = { bold: true };
      infoRow.getCell(1).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "E6E6E6" },
      };
      infoRow.getCell(2).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "E6E6E6" },
      };

      const dateRow = worksheet.addRow([
        "Generado el:",
        `${moment().format("YYYY-MM-DD HH:mm")}`,
        "",
      ]);
      dateRow.font = { italic: true };
      dateRow.getCell(1).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "F0F0F0" },
      };
      dateRow.getCell(2).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "F0F0F0" },
      };

      // Generar el buffer del archivo
      const buffer = await workbook.xlsx.writeBuffer();

      // Crear el blob y descargar el archivo
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const fileName = `bitacora_sesion_${moment().format(
        "YYYY-MM-DD HH:mm"
      )}.xlsx`;
      saveAs(blob, fileName);
    },
  },
};
</script>
